import { createBlock, defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Long Description",
  tags: ["film-text"],
  icon: "format-aside",
  description: "The long description of the film, imported from Ferve.",
  category: "Film",
  conditions: {
    multiple: false,
  },
}

export default defineBlock("film/film-long-description", (props) => {
  let contents = (
    <div className="type-body-m wysiwyg mb-10 [&_p]:max-w-none" data-mixpanel-area="Film Long Description">
      <div dangerouslySetInnerHTML={{ __html: props.film?.descriptions?.long ?? "" }} />
    </div>
  )

  return contents
})
